import { Box, ButtonBase } from '@mui/material';
import React, { useState } from 'react';
import { MessageIcon } from 'tt-ui-lib/icons';
import { useNavigate } from 'react-router-dom';
import { AppAvatar } from 'components/Avatar';
import styles from '../../../CommunityPage.module.scss';
import { getAvatarPathBySize } from '../../../../../utils/appUtils';

const CompanyListItem = ({ company }) => {
  const [openOptions, setOpenOptions] = useState(false);
  const router = useNavigate();
  const endpointMarket = process.env.REACT_APP_MARKET;

  return (
    <Box className={styles.expertsListItem} key={company.id}>
      <div
        className={styles.avatar}
        onClick={() => window.open(`${endpointMarket}/dashboard/company/${company?.id}`)}
      >
        <AppAvatar
          userName={company.company_name}
          src={getAvatarPathBySize(company.logos, 'smallPath')}
          nav={0}
          size="sm"
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%' }}>
        <div
          className={styles.info}
          onClick={() => window.open(`${endpointMarket}/dashboard/company/${company?.id}`)}
        >
          <div className={styles.name}>{company.company_name}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
          <div className={styles.buttons}>
            <ButtonBase
              type="button"
              sx={{ marginRight: '20px' }}
              className={styles.currentButton}
              onClick={() => router(`/dashboard/messaging?company=${company.id}`)}
            >
              {/* <Image src="/images/templates/message-icon.svg" width={64} height={48} /> */}
              <MessageIcon className={styles.itemIcon} />
            </ButtonBase>
            {/* <ButtonBase type="button" sx={{ marginRight: '20px' }}> */}
            {/*  <Image src="/images/templates/heart-icon.svg" width={64} height={48} /> */}
            {/* </ButtonBase> */}
          </div>
          {/* <ButtonBase */}
          {/*  className={styles.optionButton} */}
          {/*  type="button" */}
          {/*  sx={{ marginRight: '22px' }} */}
          {/*  onClick={() => setOpenOptions(true)} */}
          {/* > */}
          {/*  <MoreVertIcon width={4} height={14} sx={{ color: '#212121' }} /> */}
          {/* </ButtonBase> */}
          {openOptions && (
            <div
              style={{ marginTop: 55, marginRight: -25 }}
              className={styles.optionsWindow}
              onMouseLeave={() => setOpenOptions(false)}
            >
              <ButtonBase className={styles.options} onClick={() => setOpenOptions(false)}>
                Follow
              </ButtonBase>
              <ButtonBase
                className={styles.options}
                onClick={() => setOpenOptions(false)}
                sx={{ marginTop: '16px' }}
              >
                Connect
              </ButtonBase>
            </div>
          )}
        </div>
      </div>
    </Box>
  );
};

export default CompanyListItem;
